/** Shared copy for the full-size illustration and its readable mobile layout. */
export const accountTiers = [
  { name: 'Tier 3', lines: ['Programmatic', 'monthly'] },
  { name: 'Tier 2', lines: ['SDR-managed', 'weekly'] },
  { name: 'Tier 1', lines: ['AE-owned named', 'accounts · weekly'] }
] as const;

export const accountSignalCards = [
  {
    icon: 'document',
    title: ['Buying-group', 'activity']
  },
  { icon: 'people', title: ['Hiring and', 'role changes'] },
  { icon: 'news', title: ['Company events', 'and news'] },
  {
    icon: 'database',
    title: ['CRM context']
  }
] as const;

export const weeklyAccountPriorities = [
  { count: '2,600', lines: ['accounts monitored'] },
  { count: '180', lines: ['with new signals'] },
  { count: '12', lines: ['worth', 'reviewing'] },
  { count: '4', lines: ['prioritized for outreach'] }
] as const;

export const priorityAccountBrief = {
  company: 'Brightvault',
  tier: 'Tier 1',
  freshness: 'Updated this week',
  whyNow:
    'Buyer engagement, a new security leader, and hiring point to a timely conversation.',
  evidence: [
    { date: 'Sep 8', text: 'Two buyers engaged a competitor' },
    { date: 'Sep 5', text: 'New security leader announced' },
    { date: 'Sep 3', text: 'Five platform roles posted' }
  ],
  nextMove: 'Send a tailored note about platform security hiring.',
  owner: 'Assigned account executive'
} as const;

export const accountPriorityOutcomes = [
  { icon: 'bars', text: 'Fewer, better touches' },
  { icon: 'people', text: 'Coverage across your account list' },
  { icon: 'document', text: 'A record of signals and follow-ups' }
] as const;
